import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SessionStorageService from "../../../services/StorageService";
import AnketSorularListeAPI from "../../../apis/OB/Get/AnketSorularListeAPI";
import AnketSoruSaveAPI, { AnketSaveRequest } from "../../../apis/OB/SaveApi/AnketSoruSaveAPI";
import TcTelefonSmsControlPopup from "../../../components/OB/popups/tc-telefon-fogrulama-popup";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";


const Anket: React.FC = () => {
  const [sorular, setSorular] = useState<any[]>([]);
  const [secilenCevaplar, setSecilenCevaplar] = useState<any[]>([]);
  const [tcKimlikNo, setTcKimlikNo] = useState<string>("");
  const [cepTelefonu, setCepTelefonu] = useState<string>("");
  const [smsControlled, setSmsControlled] = useState<boolean>(false);
  const [cevaplarGonderildi, setCevaplarGonderildi] = useState(false);
  const [gonderButonuDisabled, setGonderButonuDisabled] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [popupAciklama, setPopupAciklama] = useState<string>("");
  const [aciklamaPopUpVisible, setAciklamaPopUpVisible] = useState<boolean>(false);
  let user = SessionStorageService.getUserInfo();

  useEffect(() => {
    if (user) {
      setTcKimlikNo(user.tcKimlikNo);
      setSmsControlled(true);
    }
  }, [user]);

  useEffect(() => {
    if (location.state?.anket.konuId) {
      AnketSorularListeAPI.getAnketSorulariste(location.state.anket.konuId)
        .then((response) => {
          const updatedSorular = response.data.map((soru: any) => {
            const cevaplarJson = xmlToJson(soru.cevaplarXml);
            return {
              ...soru,
              cevaplarXml: cevaplarJson.cevaplar,
            };
          });
          setSorular(updatedSorular);
        })
        .catch((error) => {
          console.error("API hatası:", error);
        });
    }
  }, [location.state?.anket]);

  function createXmlForProcedure(secilenCevaplar: any[]): string {
    let xmlString = `<ROWS>\n`;
    secilenCevaplar.forEach((cevap) => {
      Object.entries(cevap).forEach(([soruId, cevapId]) => {
        xmlString += `  <ROW>\n`;
        xmlString += `    <P_CEVAP_ID>${cevapId}</P_CEVAP_ID>\n`;
        xmlString += `  </ROW>\n`;
      });
    });
    xmlString += `</ROWS>`;
    return xmlString;
  }

  const kaydetCevabi = async () => {
    let xmlRequest = createXmlForProcedure(secilenCevaplar);
    let request = new AnketSaveRequest(xmlRequest, tcKimlikNo, undefined);
    AnketSoruSaveAPI.saveAnketSaveSave(request)
      .then((response) => {
        if (response.data.sonuc === 0) {
          // Başarılı
          setGonderButonuDisabled(true);
          setCevaplarGonderildi(true);
          setPopupAciklama("Cevaplarınız başarıyla kaydedildi.");
          setAciklamaPopUpVisible(true);
        } else if (
          response.data.sonuc === 2 &&
          response.data.sonucAciklama.includes("benzersiz kural")
        ) {
          // Benzersiz kural hatası
          setPopupAciklama("Bu ankete zaten cevap verdiniz.");
          setAciklamaPopUpVisible(true);
        } else {
          setPopupAciklama("Cevaplarınız kaydedilirken bir hata oluştu.");
          setAciklamaPopUpVisible(true);
          setGonderButonuDisabled(false);
          setCevaplarGonderildi(false);
        }
      })
      .catch((error) => {
        setPopupAciklama("Bir hata oluştu.");
        setAciklamaPopUpVisible(true);
      });
  };

  const handleCevapSecimi = (soruId: number, cevapId: number) => {
    setSecilenCevaplar((prevState: any[]) => {
      const newState = [...prevState];
      const itemIndex = newState.findIndex((item) =>
        item.hasOwnProperty(soruId)
      );
      if (itemIndex > -1) {
        newState[itemIndex] = { ...newState[itemIndex], [soruId]: cevapId };
      } else {
        newState.push({ [soruId]: cevapId });
      }
      return newState;
    });
  };

  function xmlToJson(xmlStr: string) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlStr, "application/xml");
    const jsonResult: any = {};
    const set = xmlDoc.getElementsByTagName("SET")[0];
    if (!set) return jsonResult;

    const tables = set.getElementsByTagName("TABLE");
    jsonResult["cevaplar"] = Array.from(tables).map((table) => {
      const cevapId = table.getElementsByTagName("CEVAP_ID")[0]?.textContent;
      const cevapAciklama =
        table.getElementsByTagName("CEVAP_ACIKLAMA")[0]?.textContent;
      return {
        cevapId,
        cevapAciklama,
      };
    });
    return jsonResult;
  }

  const herSoruIcinCevapSecildiMi = () => {
    return sorular.every((soru: any) => {
      return secilenCevaplar.some((secilen: any) =>
        secilen.hasOwnProperty(soru.soruId.toString())
      );
    });
  };

  useEffect(() => {
    setGonderButonuDisabled(!herSoruIcinCevapSecildiMi());
  }, [secilenCevaplar, sorular]);

  return smsControlled ? (
    <Container>

      <Card className="mb-3">
        <CardContent>
          <Typography variant="h5">{location.state != null ? location.state?.anket.konuAdi : ""}</Typography>
          {/* <Typography variant="body1">
            Sampaş 
          </Typography> */}
        </CardContent>
      </Card>
      {sorular.length > 0 ? (
        sorular.map((soru: any) => (
          <Card key={soru.soruId} className="mb-3">
            <CardContent>
              <Typography variant="h6">{`${soru.soruId}) ${soru.soruAciklama}`}</Typography>
              <RadioGroup
                name={`soru_${soru.soruId}`}
                value={
                  secilenCevaplar.find(
                    (secilen: any) =>
                      secilen[soru.soruId.toString()] !== undefined
                  )?.[soru.soruId.toString()] || ""
                }
                onChange={(e) =>
                  handleCevapSecimi(soru.soruId, parseInt(e.target.value))
                }
              >
                {Array.isArray(soru.cevaplarXml) && soru.cevaplarXml.length > 0 ? (
                  soru.cevaplarXml.map((cevap: any) => (
                    <FormControlLabel
                      key={cevap.cevapId}
                      value={cevap.cevapId}
                      control={<Radio />}
                      label={cevap.cevapAciklama}
                      disabled={cevaplarGonderildi}
                    />
                  ))
                ) : (
                  <Typography color="error" variant="body2">
                    Bu soruya ait cevap seçeneği bulunamadı.
                  </Typography>
                )}
              </RadioGroup>
            </CardContent>
          </Card>
        ))
      ) : (
        <Typography>
          Şu an anketimiz bulunmamaktadır. Göstermiş olduğunuz ilgi için
          teşekkür ederiz.
        </Typography>
      )}
      <div className="d-flex justify-content-between mt-3">
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/anketler")}
        >
          Anketlere Dön
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={kaydetCevabi}
          disabled={gonderButonuDisabled}
        >
          {cevaplarGonderildi ? (
            <span>&#10003; Cevaplar Gönderildi</span>
          ) : (
            <span>Cevapları Gönder</span>
          )}
        </Button>
      </div>
      {aciklamaPopUpVisible && (
        <AciklamaAndUserControlPopup
          open={aciklamaPopUpVisible}
          handleClose={() => setAciklamaPopUpVisible(false)}
          isUserControlPopUp={false}
          description={popupAciklama}
        />
      )}
    </Container>
  ) : (

    <TcTelefonSmsControlPopup
      smsControlledSet={setSmsControlled}
      cepTelefonuSet={setCepTelefonu}
      tcKimlikNoSet={setTcKimlikNo}
    />

  );
};

export default Anket;
